import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import EventForm from "../components/Form/Event.js";


// import { Link } from "react-router-dom";
// import ActivitiesTable from '../container/Activities/ActivitiesTable'
// import NewGif from "../components/Gif/NewGif";

// import EmptyOne from '../container/Empty/EmptyOne';

const Activities = () => {
  let show=false;
  if (show){
    return (

    <React.Fragment>
      <SEO title="Activities | ICSI 2025" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Activities"
        content="The Conference"
        contentTwo="Activities"
        linkage="/"
      />
    

      <EmptyTwo>
        <div className="entry-content">
          <h2>Social Activities </h2>

          <br></br>

          <h5>Welcome Reception, Buffet Lunches and Award Banquet are all included in the registration fees. </h5>
          <br></br>

        </div>
        <div className="entry-content">
          <h3>Activities Schedule</h3>
          <table>
        <thead>
            <tr>
                <th>Date and Time</th>
                <th>Event</th>
                <th>Location</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>August 23rd 17:00-20:00</td>
                <td>Welcome Reception</td>
                <td>Jin Yue Western Restaurant (锦悦西餐厅)</td>
            </tr>
            <tr>
                <td>August 24rd 08:30-12:00</td>
                <td>Opening Ceremony</td>
                <td>Multifunction Hall (多功能厅)</td>
            </tr>
            <tr>
                <td>August 24th 18:00-20:00</td>
                <td>Award Banquet</td>
                <td>Multifunction Hall（多功能厅）</td>
            </tr>
            <tr>
                <td>August 24th 12:00-13:00</td>
                <td>Lunch (Day I)</td>
                <td>Jin Yue Western Restaurant (锦悦西餐厅)</td>
            </tr>
            <tr>
                <td>August 25th 12:00-13:00</td>
                <td>Lunch (Day II)</td>
                <td>Jin Yue Western Restaurant (锦悦西餐厅)</td>
            </tr>
        </tbody>
    </table>

          {/* <ActivitiesTable/> */}
        </div>

        <div className="space-60"></div>

        {/* <EventForm></EventForm> */}
        <div className="reg-form">
            <iframe
              src="https://wj.qq.com/s2/15052300/68f5/"
              // frameBorder={0}
              // allowFullSreen
            ></iframe>
          </div>

        



              </EmptyTwo>

              <Footer />
              <ScrollToTop />
            </React.Fragment>
    )
  }
  else

  return (
    <React.Fragment>
      <SEO title="Activities | ICSI 2025" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Activities"
        content="The Conference"
        contentTwo="Activities"
        linkage="/"
      />
    

      <EmptyTwo>
      <div className="announce">
            <h2>The information is to be announced. </h2>
        </div>



        

        



              </EmptyTwo>

              <Footer />
              <ScrollToTop />
            </React.Fragment>
            );
};

            export default Activities;
